import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import { RiInformationLine } from '@remixicon/react';
import { getHelp, type HelpEntry } from '@/config/helpTexts';

interface InfoTipProps {
  /** helpTexts sözlüğündeki anahtar. */
  helpKey?: string;
  /** Sözlük yerine doğrudan içerik vermek için. */
  entry?: HelpEntry;
  /** İkon boyutu. */
  size?: number;
  /** Ek sınıf. */
  className?: string;
}

/**
 * ⓘ BİLGİLENDİRME İPUCU.
 *
 * AVM yönetimi yoğun terimli bir alandır. "Doluluk maliyeti oranı %7,1"
 * yazan bir kart, terimi bilmeyen kullanıcı için anlamsız bir sayıdır.
 * Bu bileşen açıklamayı ekranın akışını bozmadan, isteğe bağlı olarak sunar.
 *
 * Erişilebilirlik kararları:
 *   - Gerçek bir <button>: klavyeyle odaklanabilir ve Enter/Space ile açılır.
 *     <span> kullanmak fare olmayan kullanıcıyı içerikten tamamen mahrum bırakırdı.
 *   - trigger: ['hover', 'focus'] — hem fare hem klavye çalışır.
 *   - İkonun kendisi aria-hidden; anlamlı metin aria-label'da.
 */
export function InfoTip({ helpKey, entry, size = 14, className = '' }: InfoTipProps) {
  const help = entry ?? (helpKey ? getHelp(helpKey) : null);

  // Sözlükte olmayan bir anahtar verilmişse hiçbir şey render etme.
  // Boş bir ikon göstermek kullanıcıyı tıklamaya davet edip hayal kırıklığı yaratır.
  if (!help) return null;

  const popover = (
    <Popover className="info-tip__popover">
      <Popover.Header as="h3" className="info-tip__title">
        {help.title}
      </Popover.Header>
      <Popover.Body className="info-tip__body">
        <p className="mb-0">{help.body}</p>

        {help.formula && (
          <div className="info-tip__formula">
            <span className="info-tip__section-label">Hesaplama</span>
            <code>{help.formula}</code>
          </div>
        )}

        {help.benchmark && (
          <div className="info-tip__benchmark">
            <span className="info-tip__section-label">Referans Değer</span>
            {help.benchmark}
          </div>
        )}

        {help.caution && (
          <div className="info-tip__caution">
            <span className="info-tip__section-label">Dikkat</span>
            {help.caution}
          </div>
        )}
      </Popover.Body>
    </Popover>
  );

  return (
    <OverlayTrigger
      trigger={['hover', 'focus']}
      placement="auto"
      overlay={popover}
      delay={{ show: 150, hide: 100 }}
    >
      <button
        type="button"
        className={`info-tip ${className}`}
        aria-label={`${help.title} hakkında bilgi`}
      >
        <RiInformationLine size={size} aria-hidden="true" />
      </button>
    </OverlayTrigger>
  );
}
